import { BenefitWizardType } from "../constants/wizard-panels";
import { ResourceLink } from "./resource-link";

export class EmailDocumentDialogModel {
    email: string;

    constructor() {
        this.email = null;
    }
}
export class EmailBenefitSummaryDialogModel {
    email: string;
    id: number;
    constructor() {
        this.email = null;
        this.id = 0;
    }
}


export class DependentDialogModel {
    selectedDependentId: number;
    isWizard: boolean;
    wizardType: BenefitWizardType;

    constructor() {
        this.selectedDependentId = 0;
        this.isWizard = false;
        this.wizardType = null;
    }
}

export class FileUploadDialogModel {
    memberId: number;
    dependentId: number;
    dependentRelationship: string;
    memberName: string;
    wizardType: BenefitWizardType;
    panelName: string;
    qLERequestID: number;

    constructor() {
        this.memberId = null;
        this.dependentId = null;
        this.dependentRelationship = null;
        this.memberName = null;
        this.wizardType = null;
        this.qLERequestID = null;
    }
}

export class FileUploadDialogResponseModel {
    isComplete: boolean;
    isValid: boolean;
    files: File[];

    constructor() {
        this.isComplete = false;
        this.isValid = false;
        this.files = null;
    }
}

export class DocumentStatusDialogModel {
    dependentId: number;
    isDependentVerification: boolean;

    constructor() {
        this.dependentId = 0;
    }
}

export class ResourcesDialogModel {
    categroyResources: ResourceLink[];
    companyResources: ResourceLink[];

    constructor() {
        this.categroyResources = new Array<ResourceLink>();
        this.companyResources = new Array<ResourceLink>();
    }
}

